import { BaseModel, ModelInstance, ToFrontHook, ToBackHook, enumField, DateTimeField } from './util';
import { Game } from './game';
import { OrganizationBill } from './organization-bill';
import { Locales } from '../localization/locales';


export enum GameBillStatuses {
  pending = 1,
  paid,
  canceled,
}

export const GameBillStatusLocalization = {
  [Locales.ru]: {
    [GameBillStatuses.pending]: 'Новый',
    [GameBillStatuses.paid]: 'Оплачен',
    [GameBillStatuses.canceled]: 'Отменен',
  },
  [Locales.en]: {
    [GameBillStatuses.pending]: 'New',
    [GameBillStatuses.paid]: 'Paid',
    [GameBillStatuses.canceled]: 'Canceled',
  }
};

@ModelInstance({
  mappingFields: {
    id: 'id',
    game: 'game',
    status: 'status',
    organization_bill: 'organizationBill',
    paid_date: 'paidDate',
    price: 'price',
    created_at: 'createdAt',
  },
  relation: {
    game: Game,
    organizationBill: OrganizationBill,
    status: enumField(GameBillStatuses),
    paidDate: DateTimeField,
    createdAt: DateTimeField,
  }
})
export class GameBill extends BaseModel {
  id: number;
  game: Game;
  organizationBill: OrganizationBill;
  status: GameBillStatuses;
  price: number;
  paidDate: Date;
  createdAt: Date;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
